import React, { Suspense } from 'react';
import CircularProgress from '../../../components_base/CircularProgress';


const UserInviteList = React.lazy(() => import('../components/UserInviteList'));
function UserInviteListView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <UserInviteList {...props} />
    </Suspense>
  );
}

export default UserInviteListView;
